import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { getAideEntrepriseStub } from '../../../../config/aides-entreprises';

export default function CeeIndPage() {
  const aide = getAideEntrepriseStub('cee-ind');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="entreprises" />;
}
